<template>
  <div class="content">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Product</el-breadcrumb-item>
      <el-breadcrumb-item>RapidSeq126</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="product_content">
      <el-container style="height: 1862px;margin:30px 20px 70px 26px;">
        <el-aside width="30%" style="background-color: #f5f5f5;border-radius:10px;">
          <el-menu :default-active="instrumentsActiveId">
            <el-submenu index="1">
              <template slot="title">Instruments</template>
              <el-submenu :index="b" v-for="(v, b) in Instruments" :key="b">
                <template slot="title">{{ b }}</template>
                <el-menu-item :index="item.id" v-for="(item, index) in v" :key="index" @click="changeProduct(item)">
                  <a class="a1" :class="{'active': instrumentsActiveId === item.id}">
                    <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                    <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                    <span>{{ item.name }}</span>
                  </a>
                </el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <el-menu>
            <el-submenu index="2">
              <template slot="title">Lab-on-chip assay cartridges</template>
              <el-submenu :index="b" v-for="(v, b) in LabOnChip" :key="b">
                <template slot="title">{{ b }}</template>
                <el-menu-item index="index" v-for="(item, index) in v" :key="index" @click="changeProduct(item)">
                  <a class="a1" :class="{'active': instrumentsActiveId === item.id}">
                    <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                    <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                    <span>{{ item.name }}</span>
                  </a>
                </el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <el-menu>
            <el-submenu index="3">
              <template slot="title">Solution</template>
              <el-submenu :index="b" v-for="(v, b) in Solution" :key="b">
                <template slot="title">{{ b }}</template>
                <el-menu-item index="index" v-for="(item, index) in v" :key="index" @click="changeProduct(item)">
                  <a class="a1" :class="{'active': instrumentsActiveId === item.id}">
                    <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                    <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                    <span>{{ item.name }}</span>
                  </a>
                </el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <!-- <div class="aside-title" v-if="Instruments && Instruments.length > 0"> 
            <h2>Instruments</h2>
            <p @click="changeProduct(item)" :class="{'active': instrumentsActiveId === item.id}" v-for="(item, index) in Instruments" :key="index">
              <a class="a1">
                <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                <span>{{ item.name }}</span>
              </a>
            </p>
          </div> -->
          <!-- <div class="aside-title" v-if="LabOnChip && LabOnChip.length > 0">
            <h2>Lab-on-chip assay cartridges</h2>
            <p @click="changeProduct(item)" :class="{'active': instrumentsActiveId === item.id}" v-for="(item, index) in LabOnChip" :key="index">
              <a class="a1">
                <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                <span>{{ item.name }}</span>
              </a>
            </p>
          </div> -->
          <!-- <div class="aside-title" v-if ="Solution && Solution.length > 0">
            <h2>Solution</h2>
            <p @click="changeProduct(item)" :class="{'active': instrumentsActiveId === item.id}" v-for="(item, index) in Solution" :key="index">
              <a class="a1">
                <img v-if="instrumentsActiveId === item.id" style="margin-right:10px;" src="../assets/dot_icon.png">
                <img v-else style="margin-right:10px;" src="../assets/greydot_icon.png">
                <span>{{ item.name }}</span>
              </a>
            </p>
          </div> -->
        </el-aside>
        <el-container>
          <el-header v-if="this.productDetail.type != 'Solution'" style="height:370px;margin-bottom:26px;position:relative;">
            <img style="position:absolute;left:0;top:0;" :src="this.productDetail.detailImagePath">
            <!-- <img v-else style="position:absolute;left:0;top:0;" :src="this.productDetail.detailImagePath"> -->
            <div class="product_header" style="position:absolute;z-index:2;">
              <h2>{{ this.productDetail.name }}</h2>
              <p>
                <span class="span01">1.</span>
                <span v-if="this.productDetail.characteristic">{{ this.productDetail.characteristic.split('|', 1)[0] }}</span>
              </p>
              <p>
                <span class="span01">2.</span>
                <span v-if="this.productDetail.characteristic">{{ this.productDetail.characteristic.split('|', 2)[1] }}</span>
              </p>
              <p>
                <span class="span01">3.</span>
                <span v-if="this.productDetail.characteristic">{{ this.productDetail.characteristic.split('|', 3)[2] }}</span>
              </p>
              <p>
                <span class="span01">4.</span>
                <span v-if="this.productDetail.characteristic">{{ this.productDetail.characteristic.split('|', 4)[3] }}</span>
              </p>
              <div style="margin-top:36px;">
                <a style="margin-right:20px" class="a1" @click="goCollect(productDetail.id)">
                  <img v-if="saved" style="width:29px;height:28px;vertical-align: middle;" src="../assets/collect_icon.png">
                  <img v-else style="width:29px;height:28px;vertical-align: middle;" src="../assets/collect_icon2.png">
                </a>
                <a style="padding:9px 12px;border-radius:15.5px;font-size:18px;font-weight:bold;color:#fff;" class="btn01 a1" @click="goCart(productDetail.id)">Add to Cart</a>
<!--                <button class="btn02">eQuote</button>-->
                <a style="padding:9px 12px;border-radius:15.5px;font-size:18px;font-weight:bold;color:#fff;background:#7acbe0;text-decoration: none !important;" class="a1" href="mailto:service@kelliop.com?subject=Electronic%20quotation%20">eQuote</a>
              </div>
            </div>
          </el-header>
          <el-header v-else style="margin-bottom:26px;position:relative;height:370px;">
            <img style="position:absolute;left:0;top:0;width:100%;" :src="this.productDetail.detailImagePath">
          </el-header>
          <el-main>
            <el-tabs v-model="activeName" @tab-click="handleClick(activeName)" v-if="this.productDetail.type != 'Solution'">
              <el-tab-pane label="Overview" name="first">
                <First :Overview="this.Overview"></First>
              </el-tab-pane>
              <el-tab-pane label="Technology" name="second">
                <Second :Technology="this.Technology"></Second>
              </el-tab-pane>
              <el-tab-pane label="Datasheet&Specification" name="third">
                <Third :DatasheetAndSpecification="DatasheetAndSpecification"></Third>
              </el-tab-pane>
              <el-tab-pane label="Media" name="fourth">
                <Fourth :Media="Media"></Fourth>
              </el-tab-pane>
              <el-tab-pane label="Manuals" name="five">
                <Five :Manuals="Manuals"></Five>
              </el-tab-pane>
              <el-tab-pane label="Application notes" name="six">
                <Six :ApplicationNotes="ApplicationNotes"></Six>
              </el-tab-pane>
            </el-tabs>
            <div class="content" v-else>
              <ul class="five">
                <li class="five-item" v-for="(item, index) in Manuals" :key="index">
                  <div class="img-sty">
                    <a class="img-hover"><img class="img-wh" :src="item.imagePath" /></a>
                  </div>
                  <div class="five-mesage">
                    <p style="font-size:24px;margin-bottom:33px;color:#000;">
                      <a class="a1">{{ item.serviceName }}</a>
                    </p>
                    <p style="font-size:20px;margin-bottom:10px;color:#000;">
                      <a class="a1">{{ item.title }}</a>
                      <img v-if=" item.needLogin === 1 " src="../assets/lock_icon.png">
                    </p>
                    <p class="p3" style="font-size:16px;margin-bottom:17px;color:#8d8d8d;line-height:30px;">{{ item.remark }}</p>
                    <p @click="goDownload(item.filePath)">
                      <img style="margin-right:18px;" src="../assets/down_icon.png">
                      <a>Download documents</a></p>
                  </div>
                </li>
              </ul>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
    import { productDetail, productList, addIncrement } from '@/api/index' ;
    import { savedCreateList } from '@/api/Persona/index' ;
    import First from "./productTabs/First";
    import Second from "./productTabs/Second";
    import Third from "./productTabs/Third";
    import Fourth from "./productTabs/Fourth";
    import Five from "./productTabs/Five";
    import Six from "./productTabs/Six";
    export default {
        name: 'Product',
        components: {
          First,
          Second,
          Third,
          Fourth,
          Five,
          Six
        },
        data () {
            return {
              Instruments: [],
              instrumentsActiveId: '',
              LabOnChip: [],
              Solution: [],
              productDetail: {},
              ApplicationNotes: [],
              Datasheet: [],
              Manuals: [],
              DatasheetAndSpecification:[],
              Media: [],
              Overview: [],
              Technology: [],
              activeName: 'first',
              id: '',
              saved: false,
              keyIndex: [],
            }
        },
        created() {
          console.log(this.$route, 'this.$route');
          console.log(this.$route.query, 'this.$route.query');
          this.id = this.$route.query.id
        },
        methods: {
          // 产品页左侧列表
          getProductList() {
            productList({}).then((res) => {
                console.log(res, 'productList');
                this.Instruments = res.items.Instruments;
                // if(this.Instruments.length){
                //   this.instrumentsActiveId = this.Instruments[0][0].id;
                //   console.log(this.instrumentsActiveId, 'this.instrumentsActiveId')
                //   this.getProductDetail(this.instrumentsActiveId);
                // }
                this.keyIndex = [];
                if(this.Instruments){
                  for(var key in this.Instruments) {
                    var value = this.Instruments[key];
                    console.log(value, 'value');
                    console.log(key, 'key');
                    // this.keyIndex.push(key)
                    // console.log(this.keyIndex, 'this.keyIndex')
                    value.forEach((item,index)=> {
                      console.log(item, 'item');
                      console.log(index, 'index');
                      this.keyIndex.push(item.id)
                      console.log(this.keyIndex, 'this.keyIndex');
                    })
                  }
                }
                this.instrumentsActiveId = res.defaultId;
                this.getProductDetail(this.instrumentsActiveId);
                this.LabOnChip = res.items.LabOnChip;
                this.Solution = res.items.Solution;
                // this.getProductDetail(this.LabOnChip[0].id);
              });
          },
          // 获取product 详情
          getProductDetail(id) {
              productDetail({id: id }).then((res) => {
                console.log(res, 'productDetail');
                this.productDetail = res.tbProduct;
                this.ApplicationNotes = res.productDetailList.ApplicationNotes;
                this.DatasheetAndSpecification = res.productDetailList.DatasheetAndSpecification;
                this.Manuals = res.productDetailList.Manuals;
                this.Media = res.productDetailList.Media;
                this.Overview = res.productDetailList.Overview;
                this.Technology = res.productDetailList.Technology;
                console.log(this.productDetail.characteristic.split('|', 1), '888')
                console.log(this.productDetail.characteristic.split('|', 2), '888')
                console.log(this.productDetail.characteristic.split('|', 3), '888')
                console.log(this.productDetail.characteristic.split('|', 4), '888')
                console.log(this.productDetail.characteristic.split('|'), '888')
                this.saved = res.saved;
              });
          },
          // 切换tab
          handleClick (val) {
            console.log(val, '333');
            this.activeName = val;
          },
          // 切换左边的菜单
          changeProduct(item) {
            this.getProductDetail(item.id);
            this.instrumentsActiveId = item.id;
          },
          // 添加购物车
          goCart(id) {
            // this.$router.push({name: "Cart"});
            addIncrement({productId: id }).then((res) => {
              console.log(res, 'caaddIncrementrtAdd');
              this.$message.success("Successfully added shopping cart");
            });
          },
          // 添加收藏
          goCollect(id) {
            console.log(id, 'id')
            let params = {
              productId: id,
              // saved: this.saved
            }
            if (this.saved == false) {
              params.saved = true;
            } else {
              params.saved = false;
            }
            savedCreateList(params).then((res) => {
                console.log(res, 'savedCreateList');
                this.getProductDetail(id);
                // if (this.clickCollect == true) {
                //   this.clickCollect = false;
                // } else {
                //   this.clickCollect = true;
                // }
                // this.$message.success("添加收藏成功");
              });
          },
          // 下载
          goDownload(val){
            window.open(val);
          },
        },
        mounted() {
          // this.getProductDetail();
          this.getProductList();
        },
    }
</script>

<style scoped>
.content {
  width:100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  /* color:#000000; */
  padding-left: 30px;
  color:#323232;
}
.product_content {
  /* padding: 30px 20px 72px; */
  width:100%;
}
.product_content .active{
  color: #00546a;
}
.aside-title h2 {
  font-size: 20px;
  color: #323232;
  padding: 28px 20px 30px 20px;
  font-weight:400px;
}
.aside-title p {
  font-size: 18px;
  color: #a1a1a1;
  padding-left: 60px;
  line-height:43px;
  font-weight:400px;
}
.product_header {
  margin-left:50%;
  padding-top:75px;
}
.product_header h2{
  color:#00546a;
  font-size:32px;
  font-weight:bold;
  margin-bottom:30px;
}
.product_header p{
  font-size: 18px;
  line-height:30px;
  color: #000000;
}
.product_header p .span01 {
  color:#00546a;
  margin-right:15px;
  font-weight:bold;
}
.product_header button {
  margin-top:20px;
  padding:0px 15px;
  height:32px;
  line-height:32px;
  font-size:18px;
  font-weight:bold;
  color:#fff;
  border-radius:15px;
}
.product_header .btn01{
  background-color: #00718c;
  margin-right:25px;
}
.product_header .btn02{
  background-color: #7acbe0;
}
::v-deep .el-container {
  margin-left:20px;
}
::v-deep .el-main {
  border-radius:10px;
  box-shadow: 6px 6px 10px 5px #f5f5f5;
  padding-top: 0 !important;
}
::v-deep .el-tabs__item {
  color:#8d8d8d;
  font-size:18px;
  height:60px;
  line-height:60px;
  /* font-family: 'Myriad Pro'; */
  font-family: "Arial";
}
::v-deep .el-tabs__active-bar {
  background-color: #00718c;
  height: 5px;
}
::v-deep .el-tabs__item.is-active {
  color:#00718c;
}
::v-deep .el-breadcrumb__inner.is-link {
  color:#808080 !important;
  font-weight: 400 !important;
  font-size: 16px;
}
::v-deep .el-breadcrumb__inner {
  color: #323232;
  font-size: 16px;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #323232;
  font-size: 16px;
}
::v-deep .el-breadcrumb__separator {
  color:#323232;
  font-size: 16px;
}

.content {
  width: 100%;
  height: auto;
}
.five {
  padding: 30px 40px 0 27px;
}
.five-item {
  display:flex;
  justify-content: center;
  margin-bottom:40px;
}
.img-sty {
    width:362px;
    height:262px;
    overflow: hidden;
    max-width:362px;
    max-height:262px;
    /* border-radius: 3px; */
    /* box-shadow: 2px 2px 2px #fcfcfc; */
    /* box-shadow: 0px 0px 5px rgb(119, 119, 119, 0.3);
    text-align:center; */
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    /* width:100%;
    height:auto;
    max-height:141px;
    max-width:100%; */
    width:100%;
    height:auto;
    /* margin-top:40px; */
  }
  .five-mesage {
    flex:1;
    padding-left:30px;
  }
  .p3 {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }

  ::v-deep .el-menu{
    background-color: rgb(245, 245, 245);
    border-right: none;
  }
  ::v-deep .el-submenu__title {
    font-size: 20px;
    color: #323232;
    padding: 28px 20px 30px 20px;
    font-weight:bold;
  }
 ::v-deep .el-menu-item{
   color:#a1a1a1;
   font-size:18px;
 }
 /* ::v-deep .el-menu-item.is-active {
  color: #00718c;
 } */
 ::v-deep .el-submenu__icon-arrow {
  font-size:16px;
 }
</style>